import { LinkWithArrow } from "components";
import { useBoolean } from "hooks";
import { t } from "i18next";
import { toast } from "react-hot-toast";
import { Button, Modal, PersonInfo } from "ui";

import { useDeleteResellerOrdersNotesForAdmin } from "../../../../apis";
import { ProblemNotesForAdmin } from "../../../../constants";
import { UserBlockProps } from "../OrderModal.types";
import { OrderModalBlock } from "./blocks";

import styles from "../OrderModal.module.scss";

export const UserBlock = ({ orderDetails }: UserBlockProps) => {
  const {
    value: isDeleteNotesConfirmationOpen,
    setTrue: onOpenDeleteNotesConfirmation,
    setFalse: onCloseDeleteNotesConfirmation
  } = useBoolean(false);

  const { mutate: deleteNotes } = useDeleteResellerOrdersNotesForAdmin({
    onSuccess: () => {
      onCloseDeleteNotesConfirmation();
      toast.success(t("Reseller notes cleared successfully from all orders"));
    }
  });

  const notesTexts = orderDetails.problemNotesForAdmin.map((note) => {
    if (
      note ===
      ProblemNotesForAdmin.ResellerReachedMaxConsecutiveNumberOfFailedOrders
    ) {
      return t(
        "User reached max consecutive number of failed orders. COD payment method will be disabled for this user"
      );
    }
    return note;
  });

  return (
    <OrderModalBlock label={t("User")}>
      <div className={styles.orderModal_userBlock}>
        <div>
          <PersonInfo
            personName={`${orderDetails.reseller.firstname} ${
              orderDetails.reseller.lastname
            }`}
            image={orderDetails.reseller.image}
            bottomText={
              <LinkWithArrow
                to={{
                  pathname: `/users/all/${orderDetails.resellerId}/mainInfo`,
                  search: ""
                }}
                text="Show Profile"
              />
            }
          />
        </div>

        {notesTexts.length > 0 && (
          <div className={styles.orderModal_notesBlock}>
            <div className={styles.orderModal_notesBlock_notes}>
              {notesTexts.map((note, index) => (
                <div key={index}>{note}</div>
              ))}
            </div>

            <Button
              className={styles.orderModal_notesBlock_clearBtn}
              size="sm"
              onClick={onOpenDeleteNotesConfirmation}
            >
              {t("Clear")}
            </Button>
          </div>
        )}
      </div>

      <Modal
        isOpen={isDeleteNotesConfirmationOpen}
        title={t("Delete reseller problem notes")}
        okText="Confirm"
        contentClassName={styles.cancelOrderModal}
        onOk={() => {
          deleteNotes({
            resellerId: orderDetails.resellerId,
            notesToDelete: orderDetails.problemNotesForAdmin
          });
        }}
        onClose={onCloseDeleteNotesConfirmation}
      >
        <p className={styles.cancelOrderModal_text}>
          {t(
            "Are you sure you want to delete all problem notes for this reseller?"
          )}
        </p>
      </Modal>
    </OrderModalBlock>
  );
};
